import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  const carousels = document.querySelectorAll(
    '.solution-insights-slider__swiper'
  );

  carousels.forEach((el) => {
    const root = el.closest('.solution-insights-slider');

    if (!root) {
      return;
    }

    const nav = root.querySelector('.solution-insights-slider__nav');
    const a11y = { enabled: true };

    if (nav) {
      a11y.prevSlideMessage = nav.dataset.prevLabel;
      a11y.nextSlideMessage = nav.dataset.nextLabel;
    }

    new Swiper(el, {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 30,
      watchOverflow: true,
      keyboard: { enabled: true },
      a11y,
      navigation: {
        prevEl: root.querySelector('.solution-insights-slider__prev'),
        nextEl: root.querySelector('.solution-insights-slider__next'),
      },
      pagination: {
        el: root.querySelector('.solution-insights-slider__fraction'),
        type: 'fraction',
        renderFraction(currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
        },
      },
    });
  });
});
